import Common from '../CommonNctv';

class OfficialLive {
    constructor(_alias) {
        this.com = Common.instance;
        this.com.init();
        this.alias = _alias;
        this.loadListData();
    }
    loadListData(){

        console.log(this.com.apiDomain)
        $.ajax ( {
            type: "GET",
            contentType: "application/json",
            url: this.com.apiDomain + `/v1/channels/${this.alias}/live?game=${this.com.ip}`,
            async: 'false'
        })
        .fail( ( _e)=>{ console.log(_e) })
        .done( ( _d )=>{
            if(_d.data.liveStatus === "live")  {
                this.setLiveTemplate(_d.data);
            }
        });
    }


    setLiveTemplate(_data){
        if(_data.length < 1) return;
        const container = $('.official-live');
        const html = this.liveCardItem(_data, this.alias);

        container.html( html ).show();
    }

    
    liveCardItem(_data={}, _type){
        return `<div class="card card-horizontal is-special">
            <a href="/view?tv=${this.com.ip}&id=${_data.id}&from=${this.alias}" class="card-link">
                <div class="card-header">
                    <div class="card-header-thumb">
                        <div style="background-image:url('${_data.thumbnail}')" class="thumb-img"></div>
                        <span class="thumb-play">${require('../../../svg/play.svg')}</span>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card-content">
                        <span class="card-content-origin origin origin-live">LIVE</span>
                        <div class="card-content-title">${_data.title}</div>
                        <div class="card-content-desc">${_data.contents}</div>
                    </div>
                    <div class="card-info">
                        <div class="card-info-meta">
							<span class="meta-liveCount">
								${require('../../../svg/play.svg')}
								${_data.providerCurrentViewCount}명 시청 중
							</span>
                        </div>
                    </div>
                </div>
            </a>
        </div>`
    }
} // end of class
export default OfficialLive;
